<script>
export default {
  data: () => ({
    viewer: false
  }),
  props: ['report', 'dados'],
  watch: {
    report () {
      this.setReport()
    },
    dados () {
      this.setReport()
    }
  },
  mounted () {
    this.startView()
    this.setReport()
  },
  methods: {
    startView () {
      this.viewer = new window.Stimulsoft.Viewer.StiViewer(null, 'StiViewer', false)
      this.viewer.renderHtml('relatorio-viewer')
    },
    setReport () {
      if (this.report && this.dados) {
        let report = new window.Stimulsoft.Report.StiReport()
        report.load(this.report)
        this.viewer.report = this.setDados(report)
      }
    },
    setDados (report) {
      if (this.report && this.dados) {
        var dataSet = new window.Stimulsoft.System.Data.DataSet('Dados')
        dataSet.readJson(this.dados)
        report.dictionary.databases.clear()
        report.regData('Dados', 'Dados', dataSet)
      }
      return report
    }
  }
}
</script>

<template>
  <div id="relatorio-viewer" />
</template>
